var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBalanceMoney)?_c('navigation-menu-item',{attrs:{"title":"השקעה לטווח קצר","target-path":"balance-money"},on:{"navigate":function($event){return _vm.$emit('navigate')}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }